import React, { useState } from "react"
import MenuDown from "../../../icons/menuDropdownDown.svg?react"
import MenuUp from "../../../icons/menuDropdownUp.svg?react"
import styled from "styled-components"
import { useClickOutside } from "lib/hooks/useClickOutside"

interface DropdownButtonProps {
  onClick: Function
  children: React.ReactNode
  menu: React.ReactNode
}

const DropdownButtonWrapper = styled("div")`
  position: relative;
  display: inline-block;
`

const DropdownButtonContainer = styled("div")<{ isMenuOpen: boolean }>`
  margin-bottom: 4px;
  padding: 8px;
  color: ${({ theme }) => theme.white};
  font-size: 14px;
  font-weight: 550;
  white-space: nowrap;
  cursor: pointer;
  display: flex;
  border-radius: 4px;
  background-color: ${({ theme, isMenuOpen }) =>
    isMenuOpen ? theme.gray_100 : `transparent`};
`

const LeftContent = styled("div")`
  padding: 5px 0px 5px 10px;
`

const DropdownButton = ({ children, menu }: DropdownButtonProps) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const toggle = () => setIsMenuOpen(!isMenuOpen)

  let containerNode = useClickOutside(() => setIsMenuOpen(false))

  return (
    <DropdownButtonWrapper ref={containerNode}>
      <DropdownButtonContainer onClick={toggle} isMenuOpen={isMenuOpen}>
        {children}
        <LeftContent>{isMenuOpen ? <MenuUp /> : <MenuDown />}</LeftContent>
      </DropdownButtonContainer>
      {isMenuOpen && menu}
    </DropdownButtonWrapper>
  )
}

export default DropdownButton
